var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOracles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5C12.6046 10.5 13.5 9.60457 13.5 8.5C13.5 7.39543 12.6046 6.5 11.5 6.5C10.3954 6.5 9.5 7.39543 9.5 8.5C9.5 9.60457 10.3954 10.5 11.5 10.5Z",
    stroke: "#290E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7398 4.25999C16.2977 4.81723 16.7402 5.47896 17.0422 6.20735C17.3441 6.93574 17.4995 7.7165 17.4995 8.50499C17.4995 9.29349 17.3441 10.0742 17.0422 10.8026C16.7402 11.531 16.2977 12.1928 15.7398 12.75M7.25982 12.74C6.70196 12.1828 6.25941 11.521 5.95746 10.7926C5.65551 10.0642 5.5001 9.28349 5.5001 8.49499C5.5001 7.7065 5.65551 6.92574 5.95746 6.19735C6.25941 5.46896 6.70196 4.80723 7.25982 4.24999M18.5698 1.42999C20.4445 3.30527 21.4977 5.84835 21.4977 8.49999C21.4977 11.1516 20.4445 13.6947 18.5698 15.57M4.42982 15.57C2.55511 13.6947 1.50195 11.1516 1.50195 8.49999C1.50195 5.84835 2.55511 3.30527 4.42982 1.42999",
    stroke: "#290E41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracles);
export default __webpack_public_path__ + "static/media/oracles.bc4cad911285624ca7308a95c2a51dc0.svg";
export { ForwardRef as ReactComponent };